<script>
  import { onMount, onDestroy } from "svelte";

  export let audio;
  export let totalDuration;
  export let updateCurrentTime;
  export let showCredit;

  let isMobile = !!navigator.userAgent.match(/iphone|android|blackberry/gi);
  let showPlayButton = false;
  let bufferLength = 0;
  let fftSize = 1024;
  let frequencyData = [];
  let rafId;
  let audioRef;
  let videoRef;
  let audioContext;
  let canvasRef;
  let source;
  let analyser;

  onMount(() => {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
    analyser = audioContext.createAnalyser();
    source = audioContext.createMediaElementSource(audioRef);

    const destination = audioContext.destination;
    videoRef.playsInline = true;

    analyser.fftSize = fftSize;

    analyser.connect(destination);
    source.connect(analyser);

    bufferLength = analyser.frequencyBinCount;
    frequencyData = new Uint8Array(bufferLength);

    if (audioContext.state !== "running") {
      showPlayButton = true;
    } else {
      start();
    }

    canvasRef.width = window.innerWidth;
    canvasRef.height = window.innerHeight;

    rafId = requestAnimationFrame(nextTick);
  });
  onDestroy(() => {
    cancelAnimationFrame(rafId);

    analyser.disconnect();
    source.disconnect();
  });
  function start() {
    const target = document.body;

    if (target.requestFullscreen) {
      target.requestFullscreen();
    } else if (target.webkitRequestFullscreen) {
      target.webkitRequestFullscreen();
    } else if (target.mozRequestFullScreen) {
      target.mozRequestFullScreen();
    } else if (target.msRequestFullscreen) {
      target.msRequestFullscreen();
    }

    audioContext.resume();
    audioRef.play();
    videoRef.play();

    showPlayButton = false;
  }

  function drawBar({ ctx, width, height, x, y }) {
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(x, y, width, height);
  }

  function paint() {
  const canvas = canvasRef;
  const ctx = canvas.getContext("2d");
  const CANVAS_WIDTH = canvas.width;
  const CANVAS_HEIGHT = canvas.height;

  ctx.clearRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);

  let x = 0;

  frequencyData.forEach((frequency) => {
    const height = frequency / 0.9;
    const width = (CANVAS_WIDTH / bufferLength) * 1.5;
    const y = CANVAS_HEIGHT - height;

    drawBar({
      frequency,
      ctx: ctx,
      x,
      y,
      width,
      height,
    });

    x += width + 1;
  });
}

  function nextTick() {
    analyser.getByteFrequencyData(frequencyData);

    updateCurrentTime(audioRef.currentTime);

    rafId = requestAnimationFrame(nextTick);

    paint();

    if (Math.floor(audioRef.currentTime) >= totalDuration) {
      showCredit();

      setTimeout(() => {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }

        cancelAnimationFrame(rafId);
      }, 5000);
    }
  }
</script>

<div>
  {#if showPlayButton}
    <div class="o-lyrics">
      <p><small>🌼</small></p>
      <button
        class="play-button"
        on:click={start}
        data-umami-event="Play Button"
      >
        play
      </button>
    </div>
  {/if}

  <video bind:this={videoRef} class="background-video" loop muted>
    <source src="https://r2.umarhadi.dev/e58050c0-3372-48e8-a49b-7583797ae5ee/thatdays-1-.mp4" type="video/mp4">
    Your browser does not support the video tag.
  </video>  

  <canvas bind:this={canvasRef} />
  <!-- svelte-ignore a11y-media-has-caption -->
  <audio bind:this={audioRef} src={audio} />
</div>

<style>
  audio {
    background-color: #eeeeee;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  audio::-webkit-media-controls-panel {
    background-color: #eeeeee;
  }

  canvas {
    width: 100%;
    height: 100%;
    transition: 0.8s all;
    filter: blur(8px);
  }

  @media screen and (min-width: 30em) {
    canvas {
      width: 100%;
      height: 100vh;
    }
  }
</style>
